
import filters from "@/filters";
import { Component, Vue, Watch } from "vue-property-decorator";
import AppLayout from "@/layouts/AppLayout.vue";
import { AxiosResponse } from "axios";
import MyCourseItem from "@/views/my-course/MyCourseItem.vue";
import { Action } from "vuex-class";
import ContentFooter from "@/components/ContentFooter.vue";

@Component({
  components: {
    MyCourseItem,
    AppLayout,
    ContentFooter,
  },
  filters,
})
export default class MyCourses extends Vue {
  @Action("getMyCourse", { namespace: "myCourse" })
  private getMyCourse: any;

  private search = "";
  private filter = "latest";
  private courses = [];

  @Watch("search")
  private onSearch() {
    this.getCourseData();
  }

  @Watch("filter")
  private onFilter() {
    this.getCourseData();
  }

  private get coursePagination() {
    return {
      perPage: 8,
      currentPage: 1,
      total: 0,
      items: [],
    };
  }

  private created() {
    this.getCourseData();
  }

  private getCourseData(page: number = 1) {
    this.getMyCourse({
      params: {
        page: page || 1,
        name: this.search,
        filter: this.filter,
        per_page: this.coursePagination.perPage,
      },
      success: (response: AxiosResponse) => {
        this.courses = response.data.data.data;
        this.coursePagination.total = response.data.data.total;
        this.coursePagination.items = response.data.data.data;
        this.coursePagination.currentPage = response.data.data.current_page;
        this.coursePagination.perPage = response.data.data.per_page;
        this.coursePagination.total = response.data.data.total;
      },
    });
  }
}
